import { useLocation } from "react-router-dom";
import { detectLang } from "@/lib/routes";
import { t as translate } from "@/lib/i18n";

export function useLang() {
  const { pathname } = useLocation();
  const lang = detectLang(pathname);
  return {
    lang,
    other: lang === "da" ? "en" : "da",
    t: (key) => translate(lang, key),
  };
}
